import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import FilterWrapper from '../../FilterWrapper';
import SizeSliderPopover from './SizeSliderPopover';
import { setOpenSearchFilter } from '../../../../actions';
import { t } from '../../../../helpers/t';

const FILTER_NAME = 'size';

const SIZE_CONFIG = {
  'm²': {
    capacity_multiplier: 1.3,
    step_size: 1,
    min_size: 10,
    max_size: 500,
  },
  'sq ft': {
    capacity_multiplier: 0.13,
    step_size: 10,
    min_size: 100,
    max_size: 5000,
  },
};

const SizeFilter = () => {
  const {
    openSearchFilter,
    parameters: {
      size_lteq: maxSize,
      size_gteq: minSize,
    },
  } = useSelector((state) => state.searchFilters);

  const {
    locale: {
      area: {
        unit,
        format,
      },
    },
  } = useSelector((state) => state.searchResults);

  const dispatch = useDispatch();

  const toggleFilterVisible = () => (
    openSearchFilter === FILTER_NAME
      ? dispatch(setOpenSearchFilter(null))
      : dispatch(setOpenSearchFilter(FILTER_NAME))
  );

  function setSizeDescription(format, maxSize, minSize, unit) {
    if (!(minSize || maxSize) || (minSize === SIZE_CONFIG[unit].min_size && maxSize === SIZE_CONFIG[unit].max_size)) {
      return t('directives.listings.listingFilters.spaceSize');
    }

    if (minSize && maxSize && minSize !== SIZE_CONFIG[unit].min_size && maxSize !== SIZE_CONFIG[unit].max_size) {
      return `${minSize} - ${format.replace('%n', maxSize).replace('%u', unit)}`;
    }

    if (minSize && minSize !== SIZE_CONFIG[unit].min_size) {
      return t('directives.listings.listingFilters.formatting.size.over', { gte: minSize, unit });
    }

    if (maxSize && maxSize !== SIZE_CONFIG[unit].max_size) {
      return t('directives.listings.listingFilters.formatting.size.under', { lte: maxSize, unit });
    }
  }

  let sizeDescription = setSizeDescription(format, maxSize, minSize, unit);
  useEffect(() => {
    sizeDescription = setSizeDescription(format, maxSize, minSize, unit);
  });

  return (
    <FilterWrapper>
      <SizeSliderPopover>
        <Button type={(minSize || maxSize) ? 'primary' : 'default'} onClick={() => toggleFilterVisible()}>
          {sizeDescription}
        </Button>
      </SizeSliderPopover>
    </FilterWrapper>
  );
};

export default SizeFilter;
